import { ModelBase, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class UpdateCorporateActionEventCommand extends ModelBase {
    public corporateActionEventID: number = 0;
}